import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

const Text = styled.p`
  width: 100%;
  text-: 20px;
  font-size: 11px;
  font-family: ${props => props.weight};
  font-weight: normal;
  color: #000;
  line-height: 1.2;
  text-transform: none;
  margin: 1px;
`;

const Strong = styled.span`
  font-family: ${props => props.weight};
`;
const Container = styled.div`
  display: grid;
  text-align: center;
  width: 100%;
`;

export default class SelectionInfo extends PureComponent {
  render() {
    const { currentSelection } = this.props;
    const Upholstery = currentSelection['Upholstery'];
    const FrameFinish = currentSelection['FrameFinish'];
    let frame = '';
    if (FrameFinish) {
      frame = FrameFinish.split('/').join(' / ');
    }
    const keys = Object.keys(currentSelection);
    if (keys.indexOf('Casters') !== -1) {
      keys.splice(keys.indexOf('Casters'), 1);
      keys.unshift('Casters');
    }
    if (keys.indexOf('Arms') !== -1) {
      keys.splice(keys.indexOf('Arms'), 1);
      keys.unshift('Arms');
    }
    if (keys.indexOf('Height') !== -1) {
      keys.splice(keys.indexOf('Height'), 1);
      keys.unshift('Height');
    }
    const additionalFeatures = keys
      .map(key => {
        if (key === 'Upholstery' || key === 'FrameFinish' || key === 'render')
          return null;

        return ' ' + currentSelection[key] + ' /';
      })
      .join('');
    const feature = additionalFeatures.substring(
      0,
      additionalFeatures.length - 1
    );

    return (
      <Container>
        <Text weight="HelveticaNeueLTPro-Bd"> My Selections </Text>
        <Text weight="HelveticaNeueLTPro-Md">
          <Strong weight="HelveticaNeueLTPro-Bd">Upholstery: </Strong>
          {Upholstery}
        </Text>
        <Text weight="HelveticaNeueLTPro-Md">
          <Strong weight="HelveticaNeueLTPro-Bd">Frame Finish: </Strong>
          {frame}
        </Text>
        <Text weight="HelveticaNeueLTPro-Md">
          <Strong weight="HelveticaNeueLTPro-Bd">Features: </Strong>
          {feature}
        </Text>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectionInfo.js